import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";
import { alertState } from "../../../../../recoil-store/recoil-state";

import { Button, Dialog, DialogTitle } from "@material-ui/core/";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import CheckIcon from "@material-ui/icons/Check";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import Close from '@material-ui/icons/Close';
import AutomService from "../../../../../services/AutomService/AutomService";

const useStyles = makeStyles((theme) => ({
  input: {
    backgroundColor: "#f2f2f2",
    color: "#d6d6d6",
  },
  bottomSection: {
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  formControl: {
    backgroundColor: "#F2F2F2 !important",
    width: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  button: {
    border: "none",
    borderRadius: "5px",
    width: 100,
    height: 35,
    "&:focus": {
      outline: "none",
    },
  },
  submit: {
    color: "red",
    background: "transparent",
    border: "1px solid red",
    cursor: "pointer",
  },
}));

const RunningModal = (props) => {
  const classes = useStyles();
  const setAlert = useSetRecoilState(alertState);

  const { t } = useTranslation();

  async function handleCancel() {
    const resp = await AutomService.cancelAutom({ operationId: props.operationId, mate_id: props.mateId });
    if (resp) {
      if (resp?.status) {
        //setIsCanceled(true);
        props.setFlowStatus(3);
      }
    }
    else {
      props.setFlowStatus(0);
      props.setOpen(false);
    }
  }

  async function stopAction() {
    const resp = await AutomService.stopAction({ operationId: props.operationId });
    if (resp) {
      if (resp?.status) {
        props.setOpen(false);
        setAlert(alert => ({
          ...alert,
          show: true,
          message: t("MESSAGES.AUTOMS.DESKTOP-RECORDER.DETERMINATION-STOPPED-SUCCESSFULLY"),
          severity: 'success'
        }))
      }
    }
    else {
      props.setOpen(false);
      setAlert(alert => ({
        ...alert,
        show: true,
        message: t("GENERAL.NETWORK-ERROR"),
        severity: 'error'
      }))

    }
  }

  function handleClose() {
    props.setFlowStatus(props.isDesktopRecorder ? 1 : 0);
    props.setOpen(false);
  }

  //this will add the default alert whenever you reload your page.
  useEffect(() => {
    window.onbeforeunload = function () {
      return true;
    };
    return () => {
      window.onbeforeunload = null;
    };
  }, []);

  // Displaying icon according to flow status
  function flowStatusHandler() {
    switch (props.flowStatus) {
      case 0:
      case 4:
        return <CircularProgress style={{ color: "#D7D7D7" }} />;
      case 1:
        return (
          <CheckIcon style={{ color: "#43AA41", width: "32", height: "32" }} />
        );
      case 2:
        return (
          <ErrorOutlineIcon
            style={{ color: "#D75E5E", width: "32", height: "32" }}
          />
        );
      default:
        return;
    }
  }
  // Displaying message  flow status title
  function flowStatusTitleHandler() {
    switch (props.flowStatus) {
      case 0:
        if (props.isDesktopRecorder) {
          return <span className="modal-text">{t(props.label + 'SHOW-HIGHLIGHTED-AREAS')}</span>;
        }
        return <span className="modal-text">{t("CONTENT.FLOW.AUTOM-RUNNING")}</span>;
      case 1:
        return <span className="modal-text">{t("CONTENT.FLOW.RUN-FLOW-SUCCESS")}</span>;
      case 2:
        return <span className="modal-text">{t(props.errorMessage)}</span>;
      case 3:
        return <span className="modal-text">{t("FLOW-MESSAGES.LIBRARY.GENERAL.BEING-CANCELED")}</span>;
      case 4:
        return <span className="modal-text">{t(props.label + 'PROCESS-LONGER-THAN-EXPECTED')}</span>;
      default:
        return;
    }
  }

  return (
    <Dialog id="autom-addNew-modal" data-test="autom-add-new" open={true}>
      {!props.hideTitle || (props.flowStatus === 1 || props.flowStatus === 2) ? <DialogTitle
        id="alert-dialog-title"
      >
        <div id="about-title" style={{ display: "flex", justifyContent: "space-between" }}>
          {!props.hideTitle ? props.isDesktopRecorder ? t(props.label + 'RUN-CLICK') : t("CONTENT.FLOW.RUN-FLOW") : ""}
          <div>
            {(props.flowStatus === 1 || props.flowStatus === 2) && (
              <Button data-test="cancelautom-button" onClick={handleClose}>
                <Close />
              </Button>
            )}
          </div>
        </div>
      </DialogTitle> : ""}
      <DialogContent>
        <div style={{ textAlign: "center", marginTop: 20 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {flowStatusTitleHandler()}
            </Grid>
            <Grid item xs={12}>
              {flowStatusHandler()}
            </Grid>
            {((props.flowStatus === 0 && !props.isDesktopRecorder) || (props.flowStatus === 4)) && (
              <Grid item xs={12}>
                <button
                  type="button"
                  data-test="createautom-button"
                  onClick={() => props.isDesktopRecorder ? stopAction() : handleCancel()}
                  className={`${classes.button} ${classes.submit}`}
                  style={{ backgroundColor: "#D75E5E", borderRadius: "2px", color: "#fff", border: "none" }}
                >
                  {t("CONTENT.FLOW.STOP")}
                </button>
              </Grid>
            )}
          </Grid>
        </div>
      </DialogContent>
      <DialogActions
        style={{
          justifyContent: "space-between",
          padding: "8px 24px 16px 24px",
        }}
      ></DialogActions>
    </Dialog>
  );
};

export default RunningModal;
